import * as React from 'react';

import Nav, {NavItem} from '@src/components/Nav';
import StickyNav from '@src/components/Nav/StickyNav';
import {Translations} from '@src/i18n';

import * as styles from './siteHeader.module.scss';

export interface SiteHeaderProps {
  translations?: Translations[];
  nav: NavItem[];
}

const SiteHeader = ({translations, nav}: SiteHeaderProps) => (
  <StickyNav>
    <header className={styles.header}>
      <div className={styles.content}>
        <Nav translations={translations} nav={nav} />
      </div>
    </header>
  </StickyNav>
);

export default SiteHeader;
